<template>
  <div v-bind="$attrs" class="d-flex">
    <div>{{ currentCurrencyInfo.symbol }}</div>
    <FractionFormatter :fractional-price="formatFractionalPrice(fiatPrice)" />
  </div>
</template>

<script setup lang="ts">
import { formatFractionalPrice } from "@/utils";
import FractionFormatter from "@/components/Common/Pricing/FractionFormatter.vue";
import { useCurrencies } from "@/composables";
import { defineProps, PropType } from "vue";
import { Decimal } from "@/libs/decimal";

defineProps({
  fiatPrice: {
    type: Object as PropType<Decimal>,
    required: true,
  },
});

const { currentCurrencyInfo } = useCurrencies();
</script>
